module.exports = __webpack_public_path__ + "static/media/ycard_mastercard.be4f5552.svg";